<template>
     <div
          :class="{ dashboard_heading: Brand.getBrand() == 'insurecareteams', alt_style: altstyle }"
     >
          <h1>{{ title }}</h1>
          <p
               class="description"
               v-if="!htmlDescription && description.length > 0"
               v-html="description"
          ></p>
          <div class="description" v-if="htmlDescription" v-html="description"></div>
          <hr class="dashed" />
     </div>
</template>

<script>
import Brand from '@/services/Brand';

export default {
     name: 'Welcome',
     props: {
          title: {
               type: String,
               required: true,
          },
          description: {
               type: String,
               required: false,
               default: '',
          },
          altstyle: {
               type: Boolean,
               required: false,
               default: false,
          },
          htmlDescription: {
               type: Boolean,
               required: false,
               default: false,
          },
     },
     data() {
          return {
               Brand,
          };
     },
     computed: {
          goToAddPaymentMethod() {
               this.$router.push({
                    name: 'AddPaymentMethod',
               });
          },
     },
};
</script>

<style lang="scss" scoped>
h1 {
     font-family: 'Montserrat', sans-serif;
     font-size: 38px;
     line-height: 47px;
     color: #005e86;
     font-weight: 400;
}

p {
     font-family: 'Montserrat', sans-serif;
     color: #454545;
     font-size: 16px;
     line-height: 30px;
}

.alt_style {
     h1 {
          font-size: 24px;
          line-height: 16px;
          font-family: 'Montserrat', sans-serif;
          font-weight: 400;
          color: #454545;
          margin-bottom: 16px;
     }

     p {
          font-size: 16px;
          line-height: 20px;
          font-weight: 400;
          color: #454545;
     }
}
</style>